import { WidgetAreas, WidgetSchema } from 'features/views/LayoutEditor/types'
import { getRequiredFieldsFromFilters } from 'features/views/LayoutEditor/utils'

import { SYSTEM_TABS } from './hooks/useTabsWidgetTabs'
import { TabsWidget, TabsWidgetAdminControls } from './TabsWidget'
import { TabsWidgetType } from './tabsWidgetTypes'
import { getDefaultTabChildren, getTabWidgetUrlSlug } from './tabsWidgetUtils'

export const TabsWidgetMeta: WidgetSchema<TabsWidgetType> = {
    category: 'layout',
    label: 'Tabs',
    icon: 'Folders',
    component: TabsWidget,
    adminControlsComponent: TabsWidgetAdminControls,
    isContainer: true,
    defaultAttrs: ({ view }) => {
        // Only the first tab is active by default.
        const tabs = SYSTEM_TABS.map((tab, idx) => ({ ...tab, isActive: idx === 0 }))

        return {
            tabs,
            urlSlug: getTabWidgetUrlSlug(view),
        }
    },
    defaultChildren: ({ defaultAttrs, schema, view, object, fields }) => {
        const existingTabs = defaultAttrs.tabs ?? []

        return existingTabs.reduce((acc, tab) => {
            const newWidgets = getDefaultTabChildren(tab.id, schema, view, object, fields)
            if (newWidgets.length < 1) return acc

            acc[tab.id] = newWidgets
            return acc
        }, {} as WidgetAreas)
    },
    requireFields: (attrs, fields) => {
        const fieldsSet = new Set<string>()

        for (const tab of attrs.tabs) {
            const fieldsForFilters = getRequiredFieldsFromFilters(tab.conditions, fields)
            for (const field of fieldsForFilters) {
                fieldsSet.add(field)
            }
        }

        return Array.from(fieldsSet)
    },
}
